"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation markContentComplete(
        $contentTag: String
        $lotNumber: String
        $plannerType: String
    ) {
        markContentComplete(
            input: {
                contentTag: $contentTag
                lotNumber: $lotNumber
                plannerType: $plannerType
            }
        ) {
            clientMutationId
        }
    }
`;exports.markContentComplete=e;
//# sourceMappingURL=queries.js.map
